import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-paper" data-id="element-63">
      <div className="max-w-xl mx-auto" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-brand-terracotta/40 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden shadow-sm" data-id="element-65">
          <ShieldCheckIcon className="w-12 h-12 sm:w-16 sm:h-16 text-brand-terracotta mx-auto mb-4 sm:mb-6 relative z-10" data-id="element-66" />

          <h3 className="text-lg sm:text-2xl font-serif font-bold text-brand-forest mb-3 sm:mb-4 relative z-10" data-id="element-67">
            🛡️ Pruébalo por 14 Días Sin Riesgo
          </h3>

          <p className="text-sm sm:text-base text-brand-forest font-bold leading-relaxed mb-3 sm:mb-4 relative z-10" data-id="element-68">
            Tu satisfacción es mi prioridad o te devuelvo tu dinero.
          </p>

          <p className="text-xs sm:text-sm text-brand-muted font-medium leading-relaxed relative z-10" data-id="element-69">
            No quiero tu dinero si este manual no cambia tu vida. Lee el manual,
            aplica los remedios, cultiva tu primera planta. Si en 14 días
            sientes que este conocimiento no vale 10 veces lo que pagaste,
            envíanos un email y te reembolsaremos el{' '}
            <strong className="text-brand-forest" data-id="element-70">100% de tu inversión</strong>.
            Sin preguntas, sin resentimientos.
          </p>
        </motion.div>
      </div>
    </section>;
}